import { render, staticRenderFns } from "./RemoveDatabaseConnectionByAliasDialog.vue?vue&type=template&id=0155b559&scoped=true"
import script from "./RemoveDatabaseConnectionByAliasDialog.vue?vue&type=script&lang=ts"
export * from "./RemoveDatabaseConnectionByAliasDialog.vue?vue&type=script&lang=ts"
import style0 from "./RemoveDatabaseConnectionByAliasDialog.vue?vue&type=style&index=0&id=0155b559&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0155b559",
  null
  
)

export default component.exports